import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from 'react-router-dom';
import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import HttpsRedirect from 'react-https-redirect';
import { unregister } from "./registerServiceWorker";
import "./scss/gate.css";


const configuration = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENTID,
    redirectUri: process.env.REACT_APP_SSO_DOMAIN,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_SSO_TENANTID}`,
    navigateToLoginRequestUrl: true,
  }
};


const pca = new PublicClientApplication(configuration);

// Initialize MSAL before rendering to ensure templates work correctly
pca.initialize();

// Export MSAL instance for use in other parts of the application
export const msalInstance = pca;

  
ReactDOM.render(
  <MsalProvider instance={pca}>
    <Router onUpdate={() => window.scrollTo(0, 0)}>
      <HttpsRedirect>
        <App />
      </HttpsRedirect>
    </Router>
  </MsalProvider>,
  document.getElementById("root")
);

unregister();